import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { ActiveTripComponent } from '../../active-trip/active-trip.component';
import { AlertController, ToastController } from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class ActiveTripGuard implements CanDeactivate<ActiveTripComponent> {
    constructor(private toastController: ToastController) { }

    async canDeactivate(component: ActiveTripComponent): Promise<boolean> {
        if (component.isTripActive) {
            const toast = await this.toastController.create({
                message: 'Debes finalizar el recorrido para salir',
                duration: 2000,
                position: 'bottom',
                color: 'dark',
                cssClass: 'rounded-xl font-bold'
            });
            await toast.present();
            return false;
        }
        return true;
    }
}
